const isBrowser = typeof window !== 'undefined' && typeof window.document !== 'undefined';
const isSsr = !isBrowser;

export { isBrowser, isSsr };
